"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_star_rating_component_1 = __importDefault(require("react-star-rating-component"));
require("./credentialRatingEnrollmentBlock.scss");
const credential_type_svg_1 = __importDefault(require("../../../assets/images/icons/credential-type.svg"));
const enrollment_icon_svg_1 = __importDefault(require("../../../assets/images/icons/enrollment-icon.svg"));
const credentialRatingEnrollmentBlockTranslations_json_1 = __importDefault(require("./credentialRatingEnrollmentBlockTranslations/credentialRatingEnrollmentBlockTranslations.json"));
const master_1 = require("../../../constants/master");
function CredentialRatingEnrollmentBlock(props) {
    props.addTranslation(credentialRatingEnrollmentBlockTranslations_json_1.default);
    return (react_1.default.createElement("div", { className: "rating-enrollment-wrapper" },
        react_1.default.createElement("div", { className: "rating-block" },
            react_1.default.createElement("img", { src: credential_type_svg_1.default, alt: props.type, className: "detail-icon", width: 12, height: 10 }),
            react_1.default.createElement("div", { className: "rating-column" },
                react_1.default.createElement("span", { className: "column-title" }, props.translate("rating").toString()),
                react_1.default.createElement("div", { className: "flex-row" },
                    react_1.default.createElement(react_star_rating_component_1.default, { name: "Course Rating", value: props.courseRating, starCount: 5, editing: false, starColor: (0, master_1.getMasterConfig)().primaryColor, emptyStarColor: "#D9D9D9" }),
                    react_1.default.createElement("div", { className: "sized-box" }),
                    react_1.default.createElement("span", { className: "column-desc" },
                        props.courseRating,
                        "/5 ",
                        "(",
                        props.courseRatingCount,
                        " ",
                        props.translate("ratings").toString(),
                        ")")))),
        react_1.default.createElement("div", { className: "enrollment-block" },
            react_1.default.createElement("img", { src: enrollment_icon_svg_1.default, alt: "enrollment", className: "detail-icon", width: 15, height: 13 }),
            react_1.default.createElement("div", { className: "enrollment-column" },
                react_1.default.createElement("span", { className: "column-title" }, props.translate("enrollment").toString()),
                react_1.default.createElement("span", { className: "column-desc" },
                    props.attendeeCount,
                    " ",
                    props.translate("studentsEnrolled").toString())))));
}
exports.default = CredentialRatingEnrollmentBlock;
